const Css = {

  unSyncArea(w){
    return {
      width: w + "px",
      height: "86px",
      backgroundColor: "#252525",
    }
  },
  unSyncArea2(w){
    return {
      width: w + "px",
      height: "86px",
      backgroundColor: "#efbfbd",
    }
  },
  text:{
    color: "#EAEAEA",
    fontSize: "16px",
    display: "inline-block",
    textAlign: "left",
    height: "86px",
    lineHeight: "86px",
    float: "left",
    margin: "0 0 0 30px"
  },
  unSyncBtn: {
    width: "88px",
    height: "36px",
    lineHeight: "36px",
    color: "#fff",
    textAlign: "center",
    borderRadius: "4px",
    margin: "26px 0 0 30px",
    cursor: "pointer",
    backgroundColor: "#FF2D89",
    display: "inline-block",
    float: "left"
  }
}

export default Css;